<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__accessmanagementlog}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:accessmanagementlog:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:accessmanagementlog:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="accessManagementId" label="准入id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="companyId" label="公司id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="windCooperationAgreements" label="签约主体与持牌金融机构（或银行）贷款产品合作协议照片或扫描件" header-align="center" align="center"></el-table-column>
        <el-table-column prop="windContracts" label="签约主体与借款人的贷款委托服务合同1份（已签署并能看到乙方信息及收费标准），借款人信息可脱敏" header-align="center" align="center"></el-table-column>
        <el-table-column prop="windCity" label=" 准入城市" header-align="center" align="center"></el-table-column>
        <el-table-column prop="windCompanyProfile" label="签约主体公司介绍" header-align="center" align="center"></el-table-column>
        <el-table-column prop="windLicence" label="签约主体的营业执照（加盖公章）" header-align="center" align="center"></el-table-column>
        <el-table-column prop="windLegalId" label="签约主体的法人身份证复印件" header-align="center" align="center"></el-table-column>
        <el-table-column prop="windOfficeAddress" label="办公地址的房屋租赁合同" header-align="center" align="center"></el-table-column>
        <el-table-column prop="windLiveVideo" label="真实签约现场视频一份，时长不少于1分钟（借款人脸部可打码）" header-align="center" align="center"></el-table-column>
        <el-table-column prop="contractsCooperationAgreements" label="与我司合作协议" header-align="center" align="center"></el-table-column>
        <el-table-column prop="contractsBrandAffiliation" label="品牌加盟协议" header-align="center" align="center"></el-table-column>
        <el-table-column prop="contractsBrandUse" label="品牌使用协议" header-align="center" align="center"></el-table-column>
        <el-table-column prop="contractsTechnicalServices" label="技术服务协议" header-align="center" align="center"></el-table-column>
        <el-table-column prop="contractsComplianceCommitment" label="合规承诺涵" header-align="center" align="center"></el-table-column>
        <el-table-column prop="doorwayPhoto" label="祁浩品牌加盟商易拉宝一块并放置于门头照片" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="是否有效(0无效,1有效)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="checkStatus" label="审核状态" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
        <el-table-column prop="applicationPeriod" label="申请时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新者" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deleteBy" label="删除者" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deleteTime" label="删除时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="recordTheCause" label="记录产生原因" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:accessmanagementlog:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:accessmanagementlog:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './accessmanagementlog-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/accessmanagementlog/page',
        getDataListIsPage: true,
        exportURL: '/sys/accessmanagementlog/export',
        deleteURL: '/sys/accessmanagementlog',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
